export const demoCredentials = Object.freeze({
  email: (process.env.REACT_APP_DEMO_EMAIL || '').trim(),
  password: process.env.REACT_APP_DEMO_PASSWORD || ''
});

export const isDemoConfigured = Boolean(
  demoCredentials.email && demoCredentials.password
);

export const DEMO_SESSION_KEY = 'levapan_demo_session';
